import { HelpOutline } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { topbarStore } from "shared/common/stores/topbarStore";
import HelpMenu from "./HelpMenu";
import ShortcutDrawer from "./ShortcutDrawer";
import SupportDrawer from "./SupportDrawer";

interface props {
  role: string;
}

export default function Help({ role }: props) {
  const { t } = useTranslation();

  const changeAnchorDate = topbarStore((state) => state.changeAnchorDate);
  const changeShowHelp = topbarStore((state) => state.changeShowHelp);
  const changeAnchorLang = topbarStore((state) => state.changeAnchorLang);
  const changeAnchorHelp = topbarStore((state) => state.changeAnchorHelp);
  const changeAnchorMobile = topbarStore((state) => state.changeAnchorMobile);

  // Help Button Event Handler
  const [showSupport, setShowSupport] = useState<boolean>(false);
  const [showShortcut, setShowShortcut] = useState<boolean>(false);

  //open help popover
  const handleHelpOpen = (event: React.MouseEvent<HTMLElement>) => {
    changeAnchorHelp(event.currentTarget);
    changeShowHelp(true);
    changeAnchorLang(null);
    changeAnchorDate(null);
  };
  //close mobile menu
  const handleMobileUserClose = () => {
    changeAnchorMobile(null);
  };
  //open support window
  const handleSupport = () => {
    changeShowHelp(false);
    setShowSupport(true);
    handleMobileUserClose();
  };
  //open shorcut window
  const handleShortcut = () => {
    changeShowHelp(false);
    setShowShortcut(true);
    handleMobileUserClose();
  };

  return (
    <>
      <Tooltip
        title={t("tooltip.question_mark")}
        placement="bottom"
        enterDelay={400}
        classes={{ tooltip: "infra3d-buttonDescription" }}
      >
        <IconButton
          size="medium"
          id="infra3d-helpButton"
          className="introductionHint"
          aria-label="Help"
          classes={{ root: "infra3d-iconBackground" }}
          aria-controls={"Help"}
          aria-haspopup="true"
          onClick={handleHelpOpen}
          sx={{
            color: "white",
            "@media (hover: hover)": {
              ":hover": { color: "secondary.main" },
            },
          }}
        >
          <HelpOutline fontSize="medium" />
        </IconButton>
      </Tooltip>
      <HelpMenu
        handleSupport={handleSupport}
        handleShortcut={handleShortcut}
        role={role}
      />
      <SupportDrawer
        showSupport={showSupport}
        setShowSupport={setShowSupport}
      />
      <ShortcutDrawer
        role={role}
        showShortcut={showShortcut}
        setShowShortcut={setShowShortcut}
      />
    </>
  );
}
